
import './App.css';
import Routings from './Components/Main/Routes/Routings';
function App() {
  return (
    <>
      <Routings/>
    </>
  );
}

export default App;
